export const LeagueData = {
  league_matches: [
    {
      league_name: "Power Shoot",
      Team1: "Aston",
      Team2: "Star",
      T1_point: "2",
      T2_Point: "3",
      T1_pic: "assets/team1.png",
      T2_pic: "assets/team2.png",
    },
    {
      league_name: "Power Shoot",
      Team1: "Aston",
      Team2: "Star",
      T1_point: "2",
      T2_Point: "3",
      T1_pic: "assets/team1.png",
      T2_pic: "assets/team2.png",
    },
    {
      league_name: "Power Shoot",
      Team1: "Aston",
      Team2: "Star",
      T1_point: "2",
      T2_Point: "3",
      T1_pic: "assets/team1.png",
      T2_pic: "assets/team2.png",
    },
    {
      league_name: "Power Shoot",
      Team1: "Aston",
      Team2: "Star",
      T1_point: "2",
      T2_Point: "3",
      T1_pic: "assets/team1.png",
      T2_pic: "assets/team2.png",
    },
    {
      league_name: "Power Shoot",
      Team1: "Aston",
      Team2: "Star",
      T1_point: "2",
      T2_Point: "3",
      T1_pic: "assets/team1.png",
      T2_pic: "assets/team2.png",
    },
  ],

  Team_member: [
    {
      id: 1,

      Team_pic: "assets/team2.jpg",
      location: "Palikarnai",
    },
    {
      id: 2,
      Team_pic: "assets/team3.jpg",
      location: "Palikarnai",
    },
    {
      id: 3,
      Team_pic: "assets/team22.jpg",
      location: "Palikarnai",
    },
    {
      id: 4,
      Team_pic: "assets/team12.jpg",
      location: "Palikarnai",
    },
    {
      id: 5,
      Team_pic: "assets/team15.jpg",
      location: "Palikarnai",
    },
    {
      id: 6,
      Team_pic: "assets/team18.jpg",
      location: "Palikarnai",
    },

    {
      id: 7,
      Team_pic: "assets/team19.jpg",
      location: "Palikarnai",
    },

    {
      id: 8,
      Team_pic: "assets/team9.jpg",
      location: "Palikarnai",
    },

    {
      id: 9,
      Team_pic: "assets/team8.jpg",
      location: "Palikarnai",
    },

    {
      id: 10,
      Team_pic: "assets/team4.jpg",
      location: "Palikarnai",
    },
    {
      id: 11,
      Team_pic: "assets/team6.jpg",
      location: "Palikarnai",
    },

    {
      id: 11,
      Team_pic: "assets/team13.jpg",
      location: "Palikarnai",
    },
  ],

  scoreboard: {
    under9: [
      {
        id: 1,
        name: "Outlast Blaster Blue",
        played: 7,
        win: 7,
        lose: 0,
        draw: 0,
        gd: 0,
        points: 21,
      },
      {
        id: 2,
        name: "Outlast Immortals",
        played: 7,
        win: 6,
        draw: 0,
        lose: 1,
        gd: "+23",
        points: 18,
      },
      {
        id: 3,
        name: "Outlast Rebels Blue",
        played: 7,
        win: 4,
        draw: 1,
        lose: 2,
        gd: "+15",
        points: 13,
      },
      {
        id: 4,
        name: "Outlast Predators Red",
        played: 7,
        win: 3,
        draw: 1,
        lose: 3,
        gd: "+4",
        points: 10,
      },
      {
        id: 5,
        name: "Outlast Knights",
        played: 7,
        win: 2,
        draw: 1,
        lose: 4,
        gd: "-15",
        points: 7,
      },
      {
        id: 6,
        name: "Outlast Rebels Red",
        played: 7,
        win: 2,
        draw: 0,
        lose: 5,
        gd: "-9",
        points: 6,
      },
      {
        id: 7,
        name: "Outlast Predators Blue",
        played: 7,
        win: 1,
        draw: 2,
        lose: 4,
        gd: "-13",
        points: 5,
      },
      {
        id: 8,
        name: "Outlast Predators Green",
        played: 7,
        win: 0,
        draw: 1,
        lose: 6,
        gd: "-33",
        points: 1,
      },
    ],
    under11: [
      {
        id: 1,
        name: "Outlast Immortals Blue",
        played: 5,
        win: 4,
        draw: 1,
        lose: 0,
        gd: "+20",
        points: 13,
      },
      {
        id: 2,
        name: "Outlast Predators Red",
        played: 5,
        win: 4,
        draw: 1,
        lose: 0,
        gd: "+12",
        points: 13,
      },
      {
        id: 3,
        name: "Outlast Immortals Red",
        played: 5,
        win: 3,
        draw: 0,
        lose: 2,
        gd: "+6",
        points: 9,
      },
      {
        id: 4,
        name: "Outlast Rebels Blue",
        played: 5,
        win: 2,
        draw: 0,
        lose: 3,
        gd: "-2",
        points: 6,
      },

      {
        id: 5,
        name: "Outlast Predators Blue",
        played: 5,
        win: 0,
        draw: 1,
        lose: 4,
        gd: "-17",
        points: 1,
      },

      {
        id: 6,
        name: "Outlast Knights",
        played: 5,
        win: 0,
        draw: 1,
        lose: 4,
        gd: "-19",
        points: 1,
      },
    ],

    under13: [
      {
        id: 1,
        name: "Outlast Immortals Red",
        played: 8,
        win: 8,
        lose: 0,
        draw: 0,
        gd: "+27",
        points: 24,
      },
      {
        id: 2,
        name: "Outlast Vanguards",
        played: 8,
        win: 7,
        draw: 0,
        lose: 1,
        gd: "+13",
        points: 21,
      },
      {
        id: 3,
        name: "Outlast Blaster Red",
        played: 8,
        win: 5,
        draw: 1,
        lose: 2,
        gd: "+10",
        points: 16,
      },
      {
        id: 4,
        name: "Outlast Immortals Green",
        played: 8,
        win: 3,
        draw: 1,
        lose: 4,
        gd: "-4",
        points: 10,
      },
      {
        id: 5,
        name: "Outlast Blaster Blue",
        played: 8,
        win: 3,
        draw: 0,
        lose: 5,
        gd: "-5",
        points: 9,
      },
      {
        id: 6,
        name: "Outlast Predator Red",
        played: 8,
        win: 3,
        draw: 0,
        lose: 5,
        gd: "-9",
        points: 9,
      },
      {
        id: 7,
        name: "Outlast Immortals Blue",
        played: 8,
        win: 1,
        draw: 3,
        lose: 4,
        gd: "-6",
        points: 6,
      },
      {
        id: 8,
        name: "Outlast Predator Blue",
        played: 8,
        win: 1,
        draw: 2,
        lose: 5,
        gd: "-13",
        points: 5,
      },

      {
        id: 9,
        name: "Outlast Redels",
        played: 8,
        win: 1,
        draw: 1,
        lose: 6,
        gd: "-13",
        points: 4,
      },
    ],

    under15: [
      {
        id: 1,
        name: "Outlast Vanguards",
        played: 9,
        win: 7,
        lose: 2,
        draw: 0,
        gd: "+22",
        points: 23,
      },
      {
        id: 2,
        name: "Outlast Rebels Red",
        played: 9,
        win: 7,
        draw: 1,
        lose: 1,
        gd: "+24",
        points: 22,
      },
      {
        id: 3,
        name: "Outlast Immortals Red",
        played: 9,
        win: 7,
        draw: 1,
        lose: 1,
        gd: "+20",
        points: 22,
      },
      {
        id: 4,
        name: "Outlast Blaster Blue",
        played: 9,
        win: 6,
        draw: 1,
        lose: 2,
        gd: "+14",
        points: 19,
      },
      {
        id: 5,
        name: "Outlast Rebels Blue",
        played: 9,
        win: 4,
        draw: 0,
        lose: 5,
        gd: "-5",
        points: 12,
      },
      {
        id: 6,
        name: "Outlast Immortals Green",
        played: 9,
        win: 3,
        draw: 2,
        lose: 4,
        gd: "-7",
        points: 11,
      },
      {
        id: 7,
        name: "Outlast Predators Red",
        played: 9,
        win: 3,
        draw: 1,
        lose: 5,
        gd: "-8",
        points: 10,
      },
      {
        id: 8,
        name: "Outlast Immortals Blue",
        played: 9,
        win: 3,
        draw: 0,
        lose: 6,
        gd: "-5",
        points: 9,
      },

        {
        id: 9,
        name: "Outlast Blasters Red",
        played: 9,
        win: 0,
        draw: 1,
        lose: 8,
        gd: "-24",
        points: 1,
      },

        {
        id: 8,
        name: "Outlast Predators Blue",
        played: 9,
        win: 0,
        draw: 1,
        lose: 8,
        gd: "-31",
        points: 1,
      },
    ],
  },
};
